import styled from "styled-components";

export const Container = styled.div`
  display: grid;
  grid-template-columns: 50% 1fr;
  width: 100%;
  gap: 12px;
`;
